<div class="saved-container">
  <div class="saved-header">
    <div class="saved-title">
      <ddc-text-gradient
        class="text-xl"
        [_icon]="'bookmark'"
        [_text]="'Bookmark Collections'"
        [_type]="'1'"
      ></ddc-text-gradient>
    </div>
    <!-- ! Header -->
    <div class="saved-header-buttons">
      <ddc-button-n-one
        class="saved-add-btn"
        [_dynamicRoute]="'/collections/all_items'"
        [_icon]="'apps'"
        [_label]="'See All'"
      ></ddc-button-n-one>
      <ddc-button-n-one
        class="saved-add-btn"
        [_hasBorder]="true"
        [_icon]="'add'"
        [_label]="'Add Collection'"
        (click)="openAddDialog('bookmark-group')"
      ></ddc-button-n-one>
    </div>
  </div>
  <mat-divider style="margin-bottom: 10px; margin-top: 20px"></mat-divider>
  <!-- ! Groups -->
  <div class="saved-groups">
    <div>
      <div *ngIf="!_isCollectionsLoading">
        <div
          class="collections-container"
          infiniteScroll
          [infiniteScrollDistance]="2"
          [infiniteScrollThrottle]="300"
          [scrollWindow]="true"
          (scrolled)="onCollectionsScroll()"
        >
          <div *ngFor="let coll of _collections">
            <!-- TODO : sort words based on latest -> bigger ids upper -->
            <ddc-collection [dynamicRoute]="'/collections/' + coll.id + '/' + coll.name" [elem]="coll">
            </ddc-collection>
          </div>
        </div>
      </div>
    </div>
    <div class="word-skeletons" *ngIf="_isCollectionsLoading" style="display: flex">
      <ddc-loading-skeleton></ddc-loading-skeleton>
    </div>
    <ddc-not-available
      *ngIf="_collections.length === 0 && !_isCollectionsLoading"
      [_elem]="'Collection'"
    ></ddc-not-available>
  </div>
</div>
